export const _brandBoardDenorm = (board) => {
  if (board?.brandBoard) {
    return {
      ...board.brandBoard,
      ...board,
    };
  }
  return board;
};
